module.exports = __webpack_public_path__ + "h5/img/wuzhou2@2x.b87c05af.png";